import { observer } from "mobx-react-lite";
import Skeleton from "react-loading-skeleton";
import type { ContentfulAdventCalendarSlot } from "../../../common/types/cmsTypes";
import ErrorAlertWithOptionalTracking from "../../ErrorAlertWithOptionalTracking";
import AdventCalendarArticleContent from "./AdventCalendarArticleContent";
import { useAdventCalendarCampaign } from "./useAdventCalendarCampaign";

type AdventCalendarArticleProps = {
   adventCalendarArticleContent: ContentfulAdventCalendarSlot;
   isPreview?: boolean;
};

const AdventCalendarArticle = (props: AdventCalendarArticleProps) => {
   const { campaign, isLoading, isBeforeOpening, errorTrackingText } = useAdventCalendarCampaign();
   const { date, question } = props.adventCalendarArticleContent.fields;
   const requiresCampaign = !props.isPreview && !!(date || question);
   if (requiresCampaign && isLoading) {
      return <Skeleton height={500} />;
   }
   if (requiresCampaign && !campaign) {
      return (
         <ErrorAlertWithOptionalTracking
            showCloseButton={false}
            gaErrorTracking={{ context: "advent_calendar_article", text: errorTrackingText }}
         >
            Julekalenderen kunne ikke lastes.
         </ErrorAlertWithOptionalTracking>
      );
   }
   return (
      <AdventCalendarArticleContent
         key={props.adventCalendarArticleContent.sys.id}
         {...props}
         campaign={campaign}
         isBeforeOpening={isBeforeOpening}
      />
   );
};

export default observer(AdventCalendarArticle);
